import type { Locale } from "../schema/Locale.js";

const eurFormatCache: Partial<Record<Locale, Intl.NumberFormat>> = {};
function createEurFormat(locale: Locale): Intl.NumberFormat {
	const cached = eurFormatCache[locale];
	if (cached) {
		return cached;
	}

	const format = new Intl.NumberFormat(locale, {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
	eurFormatCache[locale] = format;
	return format;
}

/**
 * Format a CZK amount as an approximate EUR equivalent using the competition's
 * `eurRate` (CZK per 1 EUR — the same rate the payment QR uses). Returns `null`
 * when no usable rate is available so callers can omit the secondary figure
 * entirely instead of rendering a bogus number.
 */
export function formatEur(amountCzk: number, eurRate: number | undefined, locale: Locale): string | null {
	if (eurRate === undefined || eurRate <= 0) {
		return null;
	}
	return createEurFormat(locale).format(amountCzk / eurRate);
}
